angular.module('mercury.modules.time.clock')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Time.ClockList', {
    url: '/timeclock/staff-clocks-old?report',
    controller: 'TimeClockListCtrl',
    templateUrl: 'modules/time/clock/list.tpl.html'
  });

  $stateProvider.state('Time.ClockAudit', {
    url: '/clockin/audit',
    controller: 'TimeClockAuditCtrl',
    templateUrl: 'modules/time/clock/audit.tpl.html',
    data: {
      menuLinkState: 'Time.TimeclockStaffClocks'
    }
  });

  $stateProvider.state('Time.ClockDayreport', {
    url: '/clockin/dayreport?report',
    controller: 'TimeClockDayreportCtrl',
    templateUrl: 'modules/time/clock/dayreport.tpl.html'
  });

  $stateProvider.state('Time.ClockStaffreport', {
    url: '/timeclock/punches-by-staff-old?report',
    controller: 'TimeClockStaffreportCtrl',
    templateUrl: 'modules/time/clock/staffreport.tpl.html'
  });

  // React routes below
  $stateProvider.state('Time.TimeclockStaffClocks', {
    url: '/timeclock/staff-clocks?start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl'
  });

  $stateProvider.state('Time.TimeclockPunchesByStaff', {
    url: '/timeclock/punches-by-staff?start&end&dateRange&prevDateRange',
    controller: 'ReactCtrl'
  });
}]);
